import { parseThemePreference, SYSTEM_THEME_QUERY, type ResolvedTheme, type ThemePreference } from '@/contexts/theme/shared';

const SERVER_SNAPSHOT = { theme: 'light' as ThemePreference, systemTheme: 'light' as ResolvedTheme, hydrated: false };

/** storage key 由区域策略给出：访客站点与主站账号的偏好互不影响。 */
export function createThemeStore(storageKey: string) {
    let snapshot = SERVER_SNAPSHOT;
    let initialized = false;
    let storage: Storage | undefined;
    let media: MediaQueryList | undefined;
    const listeners = new Set<() => void>();
    const notify = () => { for (const listener of listeners) listener(); };
    function initialize() {
        if (initialized || typeof window === 'undefined') return;
        let theme: ThemePreference = 'light';
        try { storage = window.localStorage; theme = parseThemePreference(storage.getItem(storageKey)); } catch { /* 保留会话内能力。 */ }
        try { media = window.matchMedia(SYSTEM_THEME_QUERY); } catch { /* 缺少系统检测时使用亮色。 */ }
        snapshot = { theme, systemTheme: media?.matches ? 'dark' : 'light', hydrated: true };
        initialized = true;
    }
    const syncSystem = () => {
        const systemTheme = media?.matches ? 'dark' : 'light';
        if (systemTheme === snapshot.systemTheme) return;
        snapshot = { ...snapshot, systemTheme }; notify();
    };
    const syncStorage = (event: StorageEvent) => {
        if (event.storageArea && event.storageArea !== storage) return;
        if (event.key !== storageKey && event.key !== null) return;
        const theme = parseThemePreference(event.newValue);
        if (theme === snapshot.theme) return;
        snapshot = { ...snapshot, theme }; notify();
    };
    return {
        getSnapshot: () => { initialize(); return snapshot; },
        getServerSnapshot: () => SERVER_SNAPSHOT,
        subscribe(listener: () => void) {
            initialize(); listeners.add(listener);
            if (listeners.size === 1) {
                media?.addEventListener?.('change', syncSystem);
                window.addEventListener('storage', syncStorage);
            }
            return () => {
                listeners.delete(listener);
                if (listeners.size === 0) {
                    media?.removeEventListener?.('change', syncSystem);
                    window.removeEventListener('storage', syncStorage);
                }
            };
        },
        setTheme(theme: ThemePreference) {
            initialize();
            try { storage?.setItem(storageKey, theme); } catch { /* 不影响当前会话。 */ }
            if (theme === snapshot.theme) return;
            snapshot = { ...snapshot, theme }; notify();
        },
    };
}
